import { consumptionAPI } from "./clients";
const END_POINT = `/entities`;

/**
 * Endpoint to get the list of all entities available
 */
const getEntityList = () => {
  return consumptionAPI.get(END_POINT);
};
/**
 * Endpoint to get the list of all entities available
 */
const getEntityEvents = () => {
  const endpoint = "/entity_events";
  return consumptionAPI.get(endpoint);
};
/**
 * Endpoint to create a new entity
 * @param {Object} data
 */
const createEntity = data => {
  return consumptionAPI.post(END_POINT, data);
};
/**
 * Endpoint to get details of a single entity
 * @param {String} entity_id
 */
const getEntityDetails = entity_id => {
  const endpoint = `${END_POINT}/${entity_id}`;
  return consumptionAPI.get(endpoint);
};

/**
 * Gets the list of entites by category
 */
const getEntitiesByCategory = category => {
  const endpoint = `${END_POINT}?category=${category}`;
  return consumptionAPI.get(endpoint);
};

/**
 * get static entities list
 */
const getStaticEntitiesList = entity_id => {
  const endpoint = `/entity_list`;
  return consumptionAPI.post(endpoint, {
    entity_id: entity_id,
  });
};

/**
 * Get filters associated with the entities
 */
const getEntityFilters = entity_id => {
  const endpoint = `${END_POINT}/${entity_id}/filters`;
  return consumptionAPI.get(endpoint);
};

export {
  getEntityList,
  getEntityEvents,
  getEntityDetails,
  createEntity,
  getEntitiesByCategory,
  getStaticEntitiesList,
  getEntityFilters,
};
